document.addEventListener("DOMContentLoaded", function () {
    const cardReferent = document.querySelector(".single-projet-innovant__card-wrapper");
    const formationRightCol = document.querySelector(".single-projet-innovant__right-col");

    if (cardReferent) {

        if (window.innerWidth > 991) {

            let is_sticky = false;

            const positionFixed = cardReferent.getBoundingClientRect().top + window.scrollY;
            const cardReferentHeight = cardReferent.offsetHeight;

            const breadcrumbHeight = document.querySelector(".breadcrumb").offsetHeight;
            const container = document.querySelector(".single-projet-innovant");
            const containerHeight = container.offsetHeight;

            document.addEventListener("scroll", function () {

                const siteHeader = document.querySelector(".site-header.site-header--sticky");
                const siteHeaderHeight = siteHeader.offsetHeight + 25;
                const fullHeight =  breadcrumbHeight + containerHeight + siteHeaderHeight;

                console.log("Hauteur du container : " + containerHeight);

                if (window.scrollY + siteHeaderHeight + cardReferentHeight - fullHeight > 0) {
                    cardReferent.classList.remove("is-fixed");
                    cardReferent.classList.add("position-fixed-footer");
                    is_sticky = false;
                }

                if (!is_sticky && positionFixed <= window.scrollY + siteHeaderHeight && window.scrollY + siteHeaderHeight + cardReferentHeight - fullHeight < 0) {
                    cardReferent.classList.add("position-fixed");
                    cardReferent.classList.remove("position-fixed-footer");

                    if (formationRightCol) {
                        formationRightCol.style.position = "relative";
                    }

                    is_sticky = true;

                } else if (is_sticky && positionFixed > window.scrollY + siteHeaderHeight) {
                    cardReferent.classList.remove("position-fixed");
                    is_sticky = false;
                }

            });
        }
    }
})